import { EPropertyOrder, ESearchLevel } from '../../../../types-library/src'
import { State } from './types'

export const initialState: State = {
  priceFrom: 0,
  priceTo: 0,
  rooms: 0,
  bathrooms: 0,
  parkings: 0,
  propertyType: undefined,
  opportunityCriteria: undefined,
  constructionType: undefined,
  presale: false,
  latitude: 19.4195256,
  longitude: -99.162549,
  searchLevel: ESearchLevel.STATE,
  searchAddress: '',
  isSidePanelOpened: false,
  maxRegisteredPrice: 0,
  minRegisteredPrice: 0,
  opportunityCriteriaReadOnly: undefined,
  failedOpportunityCriterion: false,
  amenities: [],
  publishedDate: undefined,
  areaBounds: [],
  selectedPolygonId: undefined,
  priceDiffTo: 0,
  priceDiffFrom: 0,
  capRateFrom: 0,
  capRateTo: 0,
  priceBySqmFrom: 0,
  priceBySqmTo: 0,
  constructionYearFrom: 0,
  constructionYearTo: 0,
  capRateFilterEnabled: false,
  priceBySqmFilterEnabled: false,
  priceDiffFilterEnabled: false,
  pamRequestId: undefined,
  propertyOrder: EPropertyOrder.RECENT_PUBLISHED,
  origin: 'wiggot',
  showOnlyCommissionProperties: false,
  agencyId: undefined,
  associationIds: undefined,
  commissionRateHighRange: 0,
  commissionRateLowRange: 0,
  surfaceFrom: undefined,
  surfaceTo: undefined,
  listingsSource: 'wiggot',
  wiggotUserType: 'macrobolsa',
  locations:[]
}
